// import React, { useEffect, useState } from "react";
// import MyPageSidebar from "./MyPageSidebar";
// import "../styles/SubscriptionDetail.css";
// import { useParams, useNavigate } from "react-router-dom";
//
// const SubscriptionDetail = () => {
//     const { subscriptionId } = useParams();
//     const navigate = useNavigate();
//     const [subscriptionDetail, setSubscriptionDetail] = useState([]);
//     const [itemName, setItemName] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [showAllKeys, setShowAllKeys] = useState(false);
//     const [selectedHashKey, setSelectedHashKey] = useState(null);
//     const [showPopup, setShowPopup] = useState(false);
//     const [agreed, setAgreed] = useState(false);
//     const [showWarning, setShowWarning] = useState(false);
//
//     // 구독 데이터 가져오는 함수
//     const fetchSubscriptionData = async () => {
//         if (!subscriptionId) return;
//
//         try {
//             setIsLoading(true);
//             const response = await fetch(`/api/subscription/detail/${subscriptionId}`);
//             if (response.ok) {
//                 const data = await response.json();
//                 setSubscriptionDetail(data.subscriptionDetail || []);
//                 setItemName(data.itemName || "상품명 없음");
//             }
//         } catch (error) {
//             console.error("데이터를 불러오는 중 오류 발생:", error);
//         } finally {
//             setIsLoading(false);
//         }
//     };
//
//     useEffect(() => {
//         fetchSubscriptionData();
//     }, [subscriptionId]);
//
//     if (isLoading) return <p>로딩중...</p>;
//
//     // ✅ 라이선스 키 클릭 이벤트
//     const handleShowKey = (hashKey) => {
//         if (hashKey){
//             // 해시키가 있으면 팝업 X (반응 없음)
//             // 해시키 복사 기능 추가
//             navigator.clipboard.writeText(hashKey);
//             alert("라이선스 키가 복사되었습니다.");
//             return;
//         }
//
//         setSelectedHashKey(hashKey);
//         setShowPopup(true);
//         setAgreed(false);
//     };
//
//     // ✅ 라이선스 키 업데이트 API 호출
//     const updateHashKey = () => {
//         const selectedSub = subscriptionDetail.find((sub) => sub.hashKey === selectedHashKey);
//
//         fetch(`/api/subscription/update/${selectedSub.subscriptionListId}`, {
//             method: "PUT",
//         })
//             .then((response) => {
//                 if (response.ok) {
//                     return response.json(); // 응답 데이터 파싱
//                 } else {
//                     throw new Error("라이선스 키 확인에 실패했습니다.");
//                 }
//             })
//             .then((data) => {
//                 // 성공 시 데이터 업데이트
//                 alert("라이선스 키 확인이 완료되었습니다.");
//
//                 // 새로운 데이터로 구독 목록 업데이트
//                 fetchSubscriptionData();
//
//                 // 팝업 닫기
//                 setShowPopup(false);
//             })
//             .catch((error) => {
//                 console.error("라이선스 키 확인 중 오류 발생:", error);
//                 alert("라이선스 키 확인에 실패했습니다. 다시 시도해주세요.");
//                 setShowPopup(false);
//             });
//     };
//
//     // ✅ 상태 한글 변환 함수
//     const getStatusLabel = (status) => {
//         const statusMap = {
//             BEFORE_USE: "비활성화",
//             GRANTED: "활성화",
//             UNSUBSCRIPTION: "취소",
//             EXPIRED: "만료",
//             DENIED: "거부"
//         };
//         return statusMap[status] || "알 수 없음";
//     };
//
//     return (
//         <div className="subscription-detail">
//             <div className="mypage-sidebar-container">
//                 <MyPageSidebar />
//             </div>
//             <div className="subscription-content">
//                 <h2 className="subscription-title">상세페이지</h2>
//                 <p className="subscription-subtitle">{itemName} 현황</p>
//
//                 {/* ✅ 라이선스 키 전체 보기 */}
//                 <div className="subscription-filter">
//                     <label className="subscription-checkbox">
//                         <input
//                             type="checkbox"
//                             checked={showAllKeys}
//                             onChange={() => setShowAllKeys(!showAllKeys)}
//                         />
//                         라이선스 키 전체 보기
//                     </label>
//                 </div>
//
//                 {/* ✅ 구독 리스트 */}
//                 <table className="subscription-table">
//                     <thead>
//                     <tr>
//                         <th>상태</th>
//                         <th>라이선스 키</th>
//                         <th>기간</th>
//                         <th>구매일</th>
//                         <th>시작일</th>
//                         <th>만료일</th>
//                         <th>주문 금액</th>
//                     </tr>
//                     </thead>
//                     <tbody>
//                     {subscriptionDetail.map((sub) => (
//                         <tr key={sub.subscriptionListId}>
//                             <td>{getStatusLabel(sub.useStatus)}</td>
//                             <td
//                                 onClick={() => handleShowKey(sub.hashKey)}
//                                 className={`license-key ${sub.hashKey ? "disabled" : ""}`}
//                             >
//                                 {showAllKeys ? (sub.hashKey || "🔒") : "🔒"}
//                             </td>
//                             <td>{sub.subscriptionPeriod}개월</td>
//                             <td>{sub.purchaseDate}</td>
//                             <td>{sub.startDate || "-"}</td>
//                             <td>{sub.expireDate || "-"}</td>
//                             <td>{sub.orderPrice.toLocaleString()}원</td>
//                         </tr>
//                     ))}
//                     </tbody>
//                 </table>
//             </div>
//
//             {/* ✅ 라이선스 키 보기 팝업 */}
//             {showPopup && (
//                 <div className="popup-overlay">
//                     <div className="popup">
//                         <h3>라이선스 키 확인</h3>
//                         <p>정말 라이선스 키를 확인하시겠습니까?</p>
//
//                         <div className="popup-warning">
//                             <button onClick={() => setShowWarning(!showWarning)} className="toggle-btn">
//                                 {showWarning ? "🔽 유의사항 닫기" : "🔼 유의사항 보기"}
//                             </button>
//                             {showWarning && (
//                                 <ul className="warning-list">
//                                     <li>· 라이선스 키는 외부에 유출되지 않도록 주의해주세요.</li>
//                                     <li>· 라이선스 키를 확인 시 구매확정에 동의한 것으로 간주합니다.</li>
//                                     <li>· 다른 사람과 공유 시 불이익이 발생할 수 있습니다.</li>
//                                 </ul>
//                             )}
//                         </div>
//
//                         <label className="popup-agreement">
//                             <input
//                                 type="checkbox"
//                                 checked={agreed}
//                                 onChange={() => setAgreed(!agreed)}
//                             />
//                             유의사항을 확인하였으며, 라이선스 키를 확인하는 것에 동의합니다.
//                         </label>
//
//                         <div className="popup-buttons">
//                             <button
//                                 className="popup-btn-main"
//                                 disabled={!agreed}
//                                 onClick={updateHashKey}
//                             >
//                                 확인하기
//                             </button>
//                             <button className="popup-btn-sub" onClick={() => setShowPopup(false)}>
//                                 취소
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };
//
// export default SubscriptionDetail;

import React, { useEffect, useState } from "react";
import MyPageSidebar from "./MyPageSidebar";
import "../styles/SubscriptionDetail.css";
import { useParams } from "react-router-dom";

const SubscriptionDetail = () => {
    const { subscriptionId } = useParams();
    const [subscriptionDetail, setSubscriptionDetail] = useState([]);
    const [itemName, setItemName] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [showAllKeys, setShowAllKeys] = useState(false);
    const [selectedHashKey, setSelectedHashKey] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [agreed, setAgreed] = useState(false);
    const [showWarning, setShowWarning] = useState(false);

    // 구독 데이터 가져오는 함수
    const fetchSubscriptionData = async () => {
        if (!subscriptionId) return;

        try {
            setIsLoading(true);
            const response = await fetch(`/api/subscription/detail/${subscriptionId}`);
            if (response.ok) {
                const data = await response.json();
                setSubscriptionDetail(data.subscriptionDetail || []);
                setItemName(data.itemName || "상품명 없음");
            }
        } catch (error) {
            console.error("데이터를 불러오는 중 오류 발생:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSubscriptionData();
    }, [subscriptionId]);

    if (isLoading) return <p>로딩중...</p>;

    // 라이선스 키 클릭 이벤트
    const handleShowKey = (hashKey) => {
        if (hashKey){
            // 해시키가 있으면 팝업 X (반응 없음)
            // 해시키 복사 기능 추가
            navigator.clipboard.writeText(hashKey);
            alert("라이선스 키가 복사되었습니다.");
            return;
        }

        setSelectedHashKey(hashKey);
        setShowPopup(true);
        setAgreed(false);
    };

    // 라이선스 키 업데이트 API 호출
    const updateHashKey = () => {
        const selectedSub = subscriptionDetail.find((sub) => sub.hashKey === selectedHashKey);

        fetch(`/api/subscription/update/${selectedSub.subscriptionListId}`, {
            method: "PUT",
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("라이선스 키 확인에 실패했습니다.");
                }
            })
            .then((data) => {
                alert("라이선스 키 확인이 완료되었습니다.");
                setShowPopup(false);
                // 데이터 새로고침
                fetchSubscriptionData();
            })
            .catch((error) => {
                console.error("라이선스 키 확인 중 오류 발생:", error);
                alert("라이선스 키 확인에 실패했습니다. 다시 시도해주세요.");
                setShowPopup(false);
            });
    };

    // 상태 한글 변환 함수
    const getStatusLabel = (status) => {
        const statusMap = {
            BEFORE_USE: "비활성화",
            GRANTED: "활성화",
            UNSUBSCRIPTION: "취소",
            EXPIRED: "만료",
            DENIED: "거부"
        };
        return statusMap[status] || "알 수 없음";
    };

    return (
        <div className="subscription-detail">
            <div className="mypage-sidebar-container">
                <MyPageSidebar />
            </div>
            <div className="subscription-content">
                <h2 className="subscription-title">상세페이지</h2>
                <p className="subscription-subtitle">{itemName} 현황</p>

                {/* 라이선스 키 전체 보기 */}
                <div className="subscription-filter">
                    <label className="subscription-checkbox">
                        <input
                            type="checkbox"
                            checked={showAllKeys}
                            onChange={() => setShowAllKeys(!showAllKeys)}
                        />
                        라이선스 키 전체 보기
                    </label>
                </div>

                {/* 구독 리스트 */}
                <table className="subscription-table">
                    <thead>
                    <tr>
                        <th>상태</th>
                        <th>라이선스 키</th>
                        <th>기간</th>
                        <th>구매일</th>
                        <th>시작일</th>
                        <th>만료일</th>
                        <th>주문 금액</th>
                    </tr>
                    </thead>
                    <tbody>
                    {subscriptionDetail.map((sub) => (
                        <tr key={sub.subscriptionListId}>
                            <td>{getStatusLabel(sub.useStatus)}</td>
                            <td
                                onClick={() => handleShowKey(sub.hashKey)}
                                className={`license-key ${sub.hashKey ? "disabled" : ""}`}
                            >
                                {showAllKeys ? (sub.hashKey || "🔒") : "🔒"}
                            </td>
                            <td>{sub.subscriptionPeriod}개월</td>
                            <td>{sub.purchaseDate}</td>
                            <td>{sub.startDate || "-"}</td>
                            <td>{sub.expireDate || "-"}</td>
                            <td>{sub.orderPrice.toLocaleString()}원</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            {/* 라이선스 키 보기 팝업 */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup">
                        <h3>라이선스 키 확인</h3>
                        <p>정말 라이선스 키를 확인하시겠습니까?</p>

                        <div className="popup-warning">
                            <button onClick={() => setShowWarning(!showWarning)} className="toggle-btn">
                                {showWarning ? "🔽 유의사항 닫기" : "🔼 유의사항 보기"}
                            </button>
                            {showWarning && (
                                <ul className="warning-list">
                                    <li>· 라이선스 키는 외부에 유출되지 않도록 주의해주세요.</li>
                                    <li>· 라이선스 키를 확인 시 구매확정에 동의한 것으로 간주합니다.</li>
                                    <li>· 다른 사람과 공유 시 불이익이 발생할 수 있습니다.</li>
                                </ul>
                            )}
                        </div>

                        <label className="popup-agreement">
                            <input
                                type="checkbox"
                                checked={agreed}
                                onChange={() => setAgreed(!agreed)}
                            />
                            유의사항을 확인하였으며, 라이선스 키를 확인하는 것에 동의합니다.
                        </label>

                        <div className="popup-buttons">
                            <button
                                className="popup-btn-main"
                                disabled={!agreed}
                                onClick={updateHashKey}
                            >
                                확인하기
                            </button>
                            <button className="popup-btn-sub" onClick={() => setShowPopup(false)}>
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscriptionDetail;
